import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useHomeContext } from "./context/HomeContext";

import { ThreeDots } from "react-loader-spinner";
import {
  BsFillArrowLeftCircleFill,
  BsFillArrowRightCircleFill,
} from "react-icons/bs";
import { Sidebar, SmallSidebar, Navbar } from "./Components";
import { useAuth } from "./context/auth";
import {
  Dashboard,
  Properties,
  Login,
  Agent,
  AgentDetails,
  PropertyDetails,
  Profile,
  Ads,
  Users,
  Company,
  AdsDetail,
  CompanyRequest,
  RequestDetail,
  CompanyDetails,
  Notification,
  RealEstate,
  Banner,
  BannerDetail
} from "./Pages";
import { useThemeContext } from "./context/ThemeContext";
const App = () => {
  const { isOpen, setIsOpen, activeMenu, isSmallScreen } = useHomeContext();
  const { currentMode, setCurrentMode } = useThemeContext();
  const { token, user, checked } = useAuth();
  useEffect(() => {
    const currentThemeMode = localStorage.getItem("themeMode");
    if (currentThemeMode) {
      setCurrentMode(currentThemeMode);
    }
  }, []);
  console.log(currentMode);
  function LoginComp() {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    );
  }
  function HomeComp() {
    return (
      <>
        <div className={currentMode === "Dark" ? "dark" : ""}>
          <div className="flex relative w-full bg-main-bg dark:bg-main-dark-bg min-h-screen">
            {!isSmallScreen ? (
              <div
                className={`   ${
                  isOpen ? "w-64 p-5" : "w-20 p-2"
                } h-screen  overflow-y-scroll scrollbar-hide
    fixed transition duration-300 ease-in-out  w-full  dark:bg-secondary-dark-bg 
    shadow-lg z-50 bg-half-transparent `}
              >
                {isOpen && (
                  <BsFillArrowLeftCircleFill
                    onClick={() => setIsOpen(!isOpen)}
                    className={` text-3xl ${
                      isOpen ? "" : "rotate-180"
                    } duration-600 transition-all   text-main-color 
                   dark:text-white shadow-lg cursor-pointer absolute -right-3 top-2 z-50`}
                  />
                )}
                <Sidebar isOpen={isOpen} />
              </div>
            ) : (
              <div
                className={`overflow-y-scroll scrollbar-hide ${
                  activeMenu ? " duration-300 w-[260px] z-50" : "w-0 "
                }   w-full fixed h-screen transition duration-300 ease-in-out
                 dark:bg-secondary-dark-bg shadow-lg z-40 bg-white`}
              >
                <SmallSidebar />
              </div>
            )}

            <div
              className={` duration-300  ${
                !isSmallScreen && (isOpen ? "ml-64" : " ml-20")
              }  text-white w-full    `}
            >
              <div className="sticky top-0 z-40 w-full">
                <Navbar />
              </div>
              <Routes>
                <Route path="*" element={<Navigate to="/dashboard" />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/properties" element={<Properties />} />
                <Route path="/agents" element={<Agent />} />
                <Route path="/agents/detail/:id" element={<AgentDetails />} />
                <Route
                  path="/properties/detail/:id"
                  element={<PropertyDetails />}
                />
                <Route path="/profile" element={<Profile />} />
                <Route path="/ads" element={<Ads />} />
                <Route path="/users" element={<Users />} />
                <Route path="/companies" element={<Company />} />
                <Route path="/ads/detail/:id" element={<AdsDetail />} />
                <Route path="/company" element={<CompanyRequest />} />
                <Route path="/company/detail/:id" element={<RequestDetail />} />
                <Route
                  path="/companies/detail/:id"
                  element={<CompanyDetails />}
                />
                <Route path="/real-estates" element={<RealEstate />} />
                <Route path="/notification" element={<Notification />} />
                <Route path="/banner" element={<Banner />} />
                <Route path="/banner/detail/:id" element={<BannerDetail />} />
              </Routes>
            </div>
          </div>
        </div>
      </>
    );
  }
  function RoutComp() {
    if (token && user?.isAdmin) {
      return (
        <>
          <HomeComp />
        </>
      );
    } else {
      return <LoginComp />;
    }
  }
  return (
    <div>
      <>
        {checked ? (
          <RoutComp />
        ) : (
          <div className="h-44 flex items-center justify-center min-h-screen">
            {/* <Lottie animationData={Loader} loop={true} className="h-44"/> */}
            <ThreeDots
              height="80"
              width="80"
              radius="9"
              color="#216fed"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={true}
            />
          </div>
        )}
      </>
    </div>
  );
};

export default App;
